import React, { useState, useEffect } from "react";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
// import { ActifOverlay } from "./ActifOverlay";
import { useNavigate } from 'react-router-dom';
import { useQuery} from 'react-query';
import { useClient } from "../../../Context/ClientContext";
import { useActif } from "../../../Context/ActifContext";
import fetchActifByClient, { rechercheActif } from "../../../Data/actif_service";
import { useLocation } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { FaTimes } from "react-icons/fa";
import "./ListActif.css";
export const ListActif = ({

  search,

}) => {
  const [layout, setLayout] = useState("list");
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [sortField, setSortField] = useState(null);
  // const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  //const [isMounted, setIsMounted] = useState(false);
  const [correspondance, setCorrespondance] = useState(false);
  const{selectedClient}=useClient();
  const { actifs, setActifAttributes , setSelectedActif} = useActif();
  const [filteredActifs, setFilteredActifs] = useState([]);
  const [searchInput, setSearchInput] = useState(""); // State to store search input
  const location = useLocation();  // Capture URL query parameters
  const [localSearchInput, setLocalSearchInput] = useState("");
  const sortOptions = [
    {
      label: (
        <>
         Trier de A à Z <FaArrowUp style={{ color: "#970121" }} />
          {/* Adresse <FaArrowUp style={{ color: "##970121" }} /> */}
        </>
      ),
      value: "nom",
    },
    {
      label: (
        <>
         Trier de Z à A <FaArrowDown style={{ color: "#970121" }} />
        </>
      ),
      value: "!nom",
    },
     { label: <>Ville A → Z <FaArrowUp style={{ color: "#970121" }} /></>, value: "adresse_ville" },
  { label: <>Ville Z → A <FaArrowDown style={{ color: "#970121" }} /></>, value: "!adresse_ville" },
  ];
  const { refetch } =useQuery( ['actifData', selectedClient],  () => fetchActifByClient(setActifAttributes, selectedClient)
  ,  {
    enabled: !!selectedClient, // Enable the query only if selectedClient is truthy
    // refetchOnWindowFocus: true,
  
    // cacheTime: 1000,
    // refetchInactive:true,
    onSuccess: () => {
      // This will be called after successful refetch
      setActifAttributes({});
     
   
    },
  }
  );
  const formData = new FormData();
  formData.append("search", search)
  // rechercheActif(selectedClient , formData)
    


  useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("search") || "";

  // Sync input field value with URL
  setSearchInput(searchQuery);
  setLocalSearchInput(searchQuery); // this updates the visible input

  if (searchQuery.trim()) {
    const result = actifs.filter((actif) =>
      actif.nom.toLowerCase().includes(searchQuery.toLowerCase()) ||
      actif.reference_client.toLowerCase().includes(searchQuery.toLowerCase()) ||
      actif.adresse_rue1.toLowerCase().includes(searchQuery.toLowerCase()) ||
      actif.adresse_rue2.toLowerCase().includes(searchQuery.toLowerCase()) ||
      actif.adresse_etat.toLowerCase().includes(searchQuery.toLowerCase()) ||
      actif.adresse_cp.toLowerCase().includes(searchQuery.toLowerCase()) ||
      actif.adresse_ville.toLowerCase().includes(searchQuery.toLowerCase()) ||
      actif.adresse_pays.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredActifs(result);
    setCorrespondance(result.length === 0);
  } else {
    setFilteredActifs(actifs);
    setCorrespondance(false);
  }
}, [location.search, actifs]);
 

  // Search box 
  const renderSearchBox = () => (
    <div className="searchBox2" style={{ textAlign: "center", marginBottom: "1rem" }}>
      <span className="p-input-icon-right" style={{ position: "relative", display: "inline-block" }}>
        <i className="pi pi-search" style={{ position: "absolute", right: "10px", top: "65%", transform: "translateY(-50%)" }} />
        <InputText
          placeholder="Rechercher un actif "
          value={localSearchInput}
          onChange={(e) => {
            const value = e.target.value;
            setLocalSearchInput(value);
            navigate(`/Liste?search=${value.trim()}`);
          }}
          style={{
            width: "100%",
            maxWidth: "300px", // Add a max-width for larger screens
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        />
        {localSearchInput && (
          <FaTimes
            style={{
              position: "absolute",
              left: "11rem",
              top: "65%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#DE0737",
            }}
            onClick={() => {
              setLocalSearchInput("");
              navigate(`/Liste`);
            }}
          />
        )}
      </span>
    </div>
  );

  const renderListItem = (actifs) => {
    return (
      <div className="col-12">
        <div className="product-list-item">
          <>
            
           { /*<img src="../../default_actif.png" alt={actifs.nom} />*/}
            <div className="product-list-detail">
              
              
              
               <p className="referenceActif liste_list"> 
                
               
                  {actifs.reference_client}
                </p>
            <div className="product-name-list">{actifs.adresse_rue1}</div>
            
              
              <div className="product-list-description">
                
            
                 
               
                 
              
              {actifs.adresse_cp} {actifs.adresse_ville}, {actifs.adresse_pays} 
              
              
                
              </div>
            </div>
          </>
          <div className="product-list-action">
        
        
            <Button
              label="Voir l'actif"
              className="btn-list"
              onClick={(e) => {
                setSelectedActif(actifs)
                navigate('/detail')
                
              }}
            ></Button>
          </div>
        </div>
      </div>
    );
  };

  const renderGridItem = (actifs) => {
    return (
      <div className="md:col-4 grid-card">
        <div
          className="product-grid-item card item-actif"
          onClick={(e) => {
            // setShowModal(true);
            setSelectedActif(actifs)
            navigate('/detail')
            
           // setIdActif(result.id);

          }}
        > 
          <>
         
            <div className="product-grid-item-content">
              <div>
                {/*<img
                  src="../../default_actif.png"
                  // onError={(e) => (e.target.src = "default_actif.png")}
                  alt={actifs.nom}
                />*/}
                
              </div>
              <div className="product-name">{actifs.adresse_rue1}</div>
              <div className="product-description">
              {actifs.adresse_cp} {actifs.adresse_ville},  {" "}<br/>
                {actifs.adresse_pays}
              </div>
              <p className="referenceActif liste" style={{ textAlign: "center",color:"Black !important" }}> 
                
               
                  {actifs.reference_client}
                </p>
            </div>
          </>
        </div>
      </div>
    );
  };

  const itemTemplate = (actif, layout) => {
    if (!actif) {
      return <p> test </p>;
    }
    if (layout === "list") return renderListItem(actif);
    else if (layout === "grid") return renderGridItem(actif);
  };
  const onSortChange = (event) => {
    const value = event.value;

    if (value.indexOf("!") === 0) {
      setSortOrder(-1);
      setSortField(value.substring(1, value.length));
      setSortKey(value);
    } else {
      setSortOrder(1);
      setSortField(value);
      setSortKey(value);
    }
  };
  const renderHeader = () => {
    return (
      <div className="grid grid-nogutter ListeActif">
        {/* Left Aligned Dropdown */}
        <div className="col-3" style={{ textAlign: "left" }}>
          <Dropdown
            options={sortOptions}
            value={sortKey}
            optionLabel="label"
            placeholder="Trier par..."
            onChange={onSortChange}
          />
        </div>
  
        {/* Centered Search Box */}
        <div className="col-6" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          {renderSearchBox()}
        </div>
  
        {/* Right Aligned Data View Options */}
        <div className="col-3" style={{ textAlign: "right" }}>
          <DataViewLayoutOptions
            layout={layout}
            onChange={(e) => setLayout(e.value)}
          />
        </div>
      </div>
    );
  };
  
  

  const header = renderHeader();

  return (
    <>

      <div className="overlay">
    
        <div className="dataview-demo ">
          <div className="card">
            
              <DataView
                value={filteredActifs}
                layout={layout}
                header={header}
                itemTemplate={itemTemplate}
                emptyMessage={correspondance ?   <div
                      //className={correspondance ? "showMessage" : "NotshowMessage"}
                    >
                  Aucun actif ne correspond à cette recherche
                    </div> :"Aucun actif n'est disponible pour le moment"}
                sortOrder={sortOrder}
                sortField={sortField}
              />
            
          </div>
        
        </div>
      </div>
    </>
  );
};

